import { OrgPermissions, TeamPermissions } from "./permissions"

type RoleWithPermissions = {
	permissions: number
}

export const aggregateRolePermissions = (
	roles: RoleWithPermissions[]
): number => {
	return roles.reduce((acc, role) => acc | role.permissions, 0)
}

export const resolveOrgPermissions = (
	roles: RoleWithPermissions[],
	defaultPermissions?: number | null
) => {
	const effectivePermissions =
		aggregateRolePermissions(roles) | (defaultPermissions ?? 0)
	const isOrgAdmin =
		(effectivePermissions & OrgPermissions.ADMINISTRATOR) ===
		OrgPermissions.ADMINISTRATOR

	return {
		effectivePermissions,
		isOrgAdmin
	}
}

export const resolveTeamPermissions = (
	roles: RoleWithPermissions[],
	defaultPermissions?: number | null,
	_bypassMask = false
) => {
	const effectivePermissions =
		aggregateRolePermissions(roles) | (defaultPermissions ?? 0)
	const isTeamAdmin =
		(effectivePermissions & TeamPermissions.ADMINISTRATOR) ===
		TeamPermissions.ADMINISTRATOR

	return {
		effectivePermissions,
		isTeamAdmin
	}
}
